import React, { useState, useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { Row, Col, Button, message } from 'antd';

import { setValue } from '@microsoft/applicationinsights-core-js';
import { TextAreaCustom } from '../../../components/TextAreaCustom';
import { TitleSections } from '../../../components/TitleSections';
import { CollapseCustom } from './CollapseCustom';
import { Status } from './Status';
import { HistoricoAnalise } from './HistoricoAnalise';

import api from '../../../services/api';

export function ConsultasInternas({
  divergencias,
  historico,
  isReanalise,
  aguardandoConsultaExterna,
  observacaoInterna,
  carregarSolicitacaoAtual,
}) {
  const history = useHistory();
  const [valueStatus, setValueStatus] = useState(null);
  const [changeText, setChangeText] = useState(null);
  const [desabledBtn, setDesabledBtn] = useState(true);
  const [spinning, setSpinning] = useState(false);
  const [isExisteDivergencia, setIsExisteDivergencia] = useState(null);
  const [todasAprovadas, setTodasAprovadas] = useState(true);
  const [updateConsulta, setUpdateConsulta] = useState(false);

  const redirectAtendimentoFinalizado = () =>
    history.push('/atendimento-finalizado');
  const redirectReanaliseFinalizada = () => history.push('/historico');

  const handerData = async () => {
    setSpinning(true);
    setDesabledBtn(true);
    const dados = {
      idStatus: valueStatus,
      motivo: changeText,
      observacaoInterna,
    };
    try {
      await api.put('Atendimento/Finalizar', dados);
      message.success('Atendimento finalizado com sucesso!');
      return isReanalise
        ? redirectReanaliseFinalizada()
        : redirectAtendimentoFinalizado();
    } catch (error) {
      setSpinning(false);
      setDesabledBtn(false);
      message.error(
        error?.response?.data?.detail ||
          'Não foi possível finalizar o atendimento.'
      );
    }
  };

  const checkTodasAsConsultas = useCallback(() => {
    const statusList = divergencias?.map(item => item.idStatus);
    return setTodasAprovadas(statusList?.every(num => num === 7));
  }, [divergencias]);

  useEffect(() => {
    if (divergencias?.find(d => d.idStatus === 8)) return setDesabledBtn(true);
    if (valueStatus && isExisteDivergencia) setDesabledBtn(false);
    checkTodasAsConsultas();
  }, [
    changeText,
    valueStatus,
    isExisteDivergencia,
    updateConsulta,
    todasAprovadas,
    checkTodasAsConsultas,
  ]);
  return (
    <Row
      align="stretch"
      style={{
        minHeight: '100%',
        padding: '18px 30px 18px 21px',
      }}
    >
      <TitleSections
        title="Retorno de inconsistências"
        isHistory={!!historico?.length}
      />
      {divergencias && (
        <Col md={24} lg={24} xs={24} style={{ marginTop: 29 }}>
          <CollapseCustom
            data={divergencias}
            existeDivergencia={setIsExisteDivergencia}
            setUpdateConsulta={setUpdateConsulta}
            updateConsulta={updateConsulta}
            setChangeText={setChangeText}
            textAreaValue={changeText}
            carregarSolicitacaoAtual={carregarSolicitacaoAtual}
          />
        </Col>
      )}
      <Col
        md={24}
        lg={24}
        xs={24}
        style={{
          marginTop: 30,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-end',
        }}
      >
        <Col>
          {!!historico?.length && (
            <Col md={24} lg={24} xs={24}>
              <HistoricoAnalise historico={historico} />
            </Col>
          )}
          <Col md={24} lg={24} xs={24}>
            <TextAreaCustom
              title="Observações:"
              changeText={setChangeText}
              placeholder="Digite aqui"
              value={changeText}
            />
          </Col>
          <Row
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              margin: '11px 0',
            }}
          >
            <Status
              todasAprovadas={todasAprovadas}
              valueStatus={setValueStatus}
            />
          </Row>
          <Col
            md={24}
            lg={24}
            xs={24}
            style={{
              marginTop: 52,
            }}
            justify="center"
          >
            <Row justify="center">
              <Button
                type="primary"
                loading={spinning}
                disabled={desabledBtn}
                style={{
                  width: 161,
                  height: 56,
                  background: desabledBtn ? '#BDBDBD' : '#24A95D',
                  borderRadius: 0,
                  border: 'none',
                  color: '#FFFFFF',
                  fontWeight: 'bold',
                  marginBottom: 26,
                }}
                onClick={handerData}
              >
                {aguardandoConsultaExterna ? 'GRAVAR' : 'FINALIZAR'}
              </Button>
            </Row>
          </Col>
        </Col>
      </Col>
    </Row>
  );
}
